/* eslint-disable @typescript-eslint/no-explicit-any */
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ReactNode } from 'react';

function interactivePromise<T>(
  renderFn: (resolve: (value: T) => void, reject: (reason?: any) => void) => ReactNode
): Promise<T> {
  const wrapper = document.body.appendChild(document.createElement('div'));
  const cleanup = (res: T): T => {
    ReactDOM.unmountComponentAtNode(wrapper);
    setTimeout(() => {
      if (!wrapper || typeof wrapper.remove !== 'function') {
        return;
      }
      wrapper.remove();
    });
    return res;
  };

  return new Promise<T>((resolve, reject) => {
    ReactDOM.render(
      <Provider store={(window as any).store}>{renderFn(resolve, reject)}</Provider>,
      wrapper
    );
  })
    .then(cleanup)
    .catch((err: any) => {
      cleanup(err);
      return Promise.reject(err);
    });
}

export default interactivePromise;
